import UltMeta, { Meta } from "./UltMeta/index";

/**
 *处理状态
 */
class ShapeType extends UltMeta {
    POLYGON = new Meta(1, "多边形");
    RECTANGLE = new Meta(2, "矩形");
    CIRCLE = new Meta(3, "圆形");
}
export const SHAPE_TYPE = new ShapeType();
